export default __webpack_public_path__ + "static/media/logo_integramedica.d46d9de4.png";